export const SENSOR_PLACEHOLDER = "'sensor'"
export const START_DATE_PLACEHOLDER = 'Start_Date_Rep'
export const END_DATE_PLACEHOLDER = 'End_Date_Rep'
export const DATA_PLACEHOLDER = 'df'
